import { IconButton, Stack, Typography } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

type WorkspaceLinkBannerProps = {
  externalId: string;
  onCopy: () => void;
};

export const WorkspaceLinkBanner = ({ externalId, onCopy }: WorkspaceLinkBannerProps) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        px: 2,
        py: 1,
        bgcolor: '#fff',
        borderRadius: 1,
        border: '1px solid #e6e8ef',
        alignItems: 'center',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 700, flexGrow: 1, wordBreak: 'break-all' }}>
        {`https://workspace.dotstorming.com/${externalId}`}
      </Typography>
      <IconButton onClick={onCopy}>
        <ContentCopyOutlinedIcon />
      </IconButton>
    </Stack>
  );
};
